import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@/types/api';
import { isTokenValid } from '@/lib/auth';

interface AuthState {
  token: string | null;
  user: User | null;
  setAuth: (token: string, user: User) => void;
  clearAuth: () => void;
  updateUser: (user: Partial<User>) => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      
      setAuth: (token, user) => {
        set({ token, user });
      },
      
      clearAuth: () => {
        set({ token: null, user: null });
        localStorage.removeItem('noor-bot-auth');
      },
      
      updateUser: (updates) => {
        const currentUser = get().user;
        if (currentUser) {
          set({ user: { ...currentUser, ...updates } });
        }
      },
      
      isAuthenticated: () => {
        const { token, user } = get();
        // Presence AND client-side validity (not past its exp). Server-side
        // verification happens in AuthGuard via /api/auth/me.
        return !!token && !!user && isTokenValid(token);
      },
    }),
    {
      name: 'noor-bot-auth',
      partialize: (state) => ({ 
        token: state.token, 
        user: state.user 
      })
    }
  )
);